import React, { lazy, useState, Suspense } from "react";

import info from "../package.json";
import Startup from "./Startup";
import getVersion from "./model/getVersion";
import "./App.css";

const Deck = lazy(() => import("./Deck"));

export default function App() {
  const [id, setId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadProject = id => {
    setLoading(true);
    setId(id);
    getVersion(id).then(v => {
      window.v = v;
      if (v > info.modelVersion)
        setError("The selected model version is not supported!");
      setLoading(false);
    });
  };

  if (loading)
    return (
      <div className="loading">
        <div>Getting model version...</div>
      </div>
    );

  if (error)
    return (
      <div className="loading">
        <div>{error}</div>
      </div>
    );

  if (id) {
    return (
      <Suspense
        fallback={
          <div className="loading">
            <div>Loading model version...</div>
          </div>
        }
      >
        <Deck id={id} info={info} />
      </Suspense>
    );
  }

  return <Startup onSelect={id => loadProject(id)} />;
}



// WEBPACK FOOTER //
// ./src/App.js